import React from 'react';

export default function ImplBlock2Inputs() {
  return (
    <section className="py-24 md:py-24 px-6 md:px-16 bg-paper border-t border-line">
      <div className="max-w-[1000px] mx-auto flex flex-col md:flex-row gap-8 lg:gap-8">
        
        {/* Left Side: Copy */}
        <div className="w-full md:w-1/3 flex flex-col items-start">
          <h2 className="text-[24px] md:text-[32px] font-bold text-ink mb-6 tracking-tight leading-[1.2]">
            Partimos con una población y una necesidad operacional concreta.
          </h2>
          <p className="text-[16px] md:text-[20px] text-ink-soft leading-[1.6]">
            No necesitamos digitalizar todo para comenzar. Necesitamos los datos y reglas que realmente cambian una acción.
          </p>
        </div>

        {/* Right Side: Matrix */}
        <div className="w-full md:w-2/3 flex flex-col relative">
          
          <div className="flex flex-col gap-6 relative z-10 border-l-2 border-brand pl-8 md:pl-12">
            
            <div>
              <div className="text-[14px] font-semibold text-ink tracking-widest uppercase mb-1">
                POBLACIÓN
              </div>
              <div className="text-[16px] text-ink-soft">
                ¿Sobre quién vamos a operar?
              </div>
            </div>

            <div>
              <div className="text-[14px] font-semibold text-ink tracking-widest uppercase mb-1">
                EVIDENCIA / DATOS
              </div>
              <div className="text-[16px] text-ink-soft">
                ¿Qué información disponible permite evaluar la necesidad?
              </div>
            </div>

            <div>
              <div className="text-[14px] font-semibold text-ink tracking-widest uppercase mb-1">
                REGLAS ACORDADAS
              </div>
              <div className="text-[16px] text-ink-soft">
                ¿Qué criterios autorizados determinan elegibilidad, brecha, hito o prioridad?
              </div>
            </div>

            <div>
              <div className="text-[14px] font-semibold text-ink tracking-widest uppercase mb-1">
                CAPACIDAD
              </div>
              <div className="text-[16px] text-ink-soft">
                ¿Qué prestaciones, agendas, canales o recursos existen?
              </div>
            </div>

            <div>
              <div className="text-[14px] font-semibold text-ink tracking-widest uppercase mb-1">
                CONTRAPARTE DE RED
              </div>
              <div className="text-[16px] text-ink-soft">
                ¿Quién valida reglas, capacidad, excepciones y operación?
              </div>
            </div>

          </div>
          
        </div>
      </div>
    </section>
  );
}
